import { render, staticRenderFns } from "./VueEmail.vue?vue&type=template&id=0da37ae2&scoped=true"
import script from "./VueEmail.vue?vue&type=script&lang=js"
export * from "./VueEmail.vue?vue&type=script&lang=js"
import style0 from "./VueEmail.vue?vue&type=style&index=0&id=0da37ae2&lang=scss&scoped=true"
import style1 from "./VueEmail.vue?vue&type=style&index=1&id=0da37ae2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da37ae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da37ae2')) {
      api.createRecord('0da37ae2', component.options)
    } else {
      api.reload('0da37ae2', component.options)
    }
    module.hot.accept("./VueEmail.vue?vue&type=template&id=0da37ae2&scoped=true", function () {
      api.rerender('0da37ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueEmail/VueEmail.vue"
export default component.exports